module.exports = __webpack_public_path__ + "static/media/weixin.97d81d37.png";